import React, { memo, useState, useEffect } from 'react'
import { Button, HeadingText, BodyText, Avatar } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import { PP_LOGGED_OUT_URL } from '../../../../constants/constants'
import { fptiCustomImpression } from '../../../../utils'
import DATAPRIVACY_FPTI from '../../../../config/data-privacy-fpti'
const loggedOutFPTI = DATAPRIVACY_FPTI.LOGGED_OUT

const VerificationError = memo(() => {
  const [impressionDone, setImpressionDone] = useState(false)

  useEffect(() => {
    if (!impressionDone) {
      setImpressionDone(true)
      fptiCustomImpression(loggedOutFPTI.EMAIL_LINK_CANT_CONFIRMED_IMPRESSION)
    }
  }, [])

  const onClickRetry = (event) => {
    event.preventDefault()
    location.href = PP_LOGGED_OUT_URL
  }

  return (
    <>
      <section className="page-body-container">
        <div className="inner-container">
          <section className="common-screen text-center">
            <div className="flex-center">
              <Avatar
                src="https://www.paypalobjects.com/paypal-ui/illustrations/focused/svg/empty-warning.svg"
                className="focusedimg"
                alt="error"
              />
            </div>
            <HeadingText size="sm" className="">
              <Message id="dsrLoggedout.emailconfirmationfailed.header" />
            </HeadingText>

            <BodyText>
              <Button tertiary onClick={onClickRetry} className="">
                <Message id="dsrLoggedout.emailconfirmationfailed.tryagain" />
                <span className="tertiary-button--icon" />
              </Button>
            </BodyText>
          </section>
        </div>
      </section>
    </>
  )
})
VerificationError.displayName = 'VerificationError'

export default VerificationError
